var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content--sub"},[(!_vm.$store.getters.solutionsLoaded || !_vm.section)?_c('OverlayLoader'):_vm._e(),(_vm.section)?[_c('MyHeader',{attrs:{"breadcrumbItems":[
      {
        name: _vm.section.value,
        path: _vm.$route.path
      }
    ]}}),_c('header',{staticClass:"content-header"},[_c('h1',[_vm._v(_vm._s(_vm.section.value))])]),_c('div',{staticClass:"container main-content"},[_c('div',{staticClass:"row boxes-row"},_vm._l((_vm.solutions),function(solution){return _c('div',{key:solution.idSolution,staticClass:"col-lg-3"},[_c('BoxStory',{attrs:{"box":solution}})],1)}),0)])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }